<script>
import { LANGUAGE } from '@/utils/constant'
export default {
  data () {
    return {
      antProvideProps: {
        locale: this.getAntdLangFile(this.$store.state.lang)
      }
    }
  },
  watch: {
    '$store.state.lang': {
      deep: true,
      handler: function (newVal, oldVal) {
        this.setLanguage(newVal)
      }
    }
  },
  created () {
    // 加载本地语言或者初始化语言
    this.$store.commit('initLanguage')
  },
  methods: {
    getAntdLangFile(lang){
      if (lang === 'US') {
        return require('ant-design-vue/es/locale-provider/en_US').default
      }
      return require('ant-design-vue/es/locale-provider/zh_CN').default
    },
    setLanguage (lang) {
      this.$i18n.locale = lang
      switch (lang) {
        case LANGUAGE.CHINESE:
          this.antProvideProps.locale = require('ant-design-vue/es/locale-provider/zh_CN').default
          break
        case LANGUAGE.ENGLISH:
        default:
          this.antProvideProps.locale = require('ant-design-vue/es/locale-provider/en_US').default
          break
      }
    },
    changeLang (lang) {
      this.$store.commit('setLanguage', lang)
      this.$nextTick(_ => {
        this.$message.success(this.$t('switchSuccess'))
      })
    }
  }
}
</script>
